import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {SILVER} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface FillPlateTransferSourceIconProps {
  typedValue: TypedValue;
}
export default function FillPlateTransferSourceIcon({
  typedValue,
}: FillPlateTransferSourceIconProps): JSX.Element | null {
  if (typedValue.type === BaseTypedValueType.STRING) {
    return (
      <div className={css(styles.iconWrapper)}>
        <BenchlingIcon
          className={css(styles.icon)}
          icon={formatTypedValue(typedValue) as BenchlingIconName}
        />
      </div>
    );
  }
  return null;
}

const styles = StyleSheet.create({
  iconWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  icon: {
    color: SILVER,
    width: '12px',
    height: '12px',
    margin: 'auto',
  },
});
